import React from 'react';
import { useAuth } from '../../teal-react/utils/token';

const AdminOnly = ({ children }: { children: any }) => {
  const { user } = useAuth();
  if (!user?.isAdmin) {
    return null;
  }
  return <>{children}</>;
};

export default AdminOnly;
